import { processRawInput } from "./processRawInput";
import ItemPlugin from "./TextItem/TextItem";
import { userShare } from "./userShare";

export default function registerTextPlugin() {
  return { ItemPlugin, userShare, processRawInput };
}
